import React from 'react'

import { Colors } from 'common-constants/colors'

export const ArrowMessageSvg = ({
  size = 24,
  strokeColor = Colors.link,
}: {
  size?: number
  strokeColor?: string
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <g fill="none" fillRule="evenodd">
      <polyline
        stroke={strokeColor}
        strokeWidth="1.5"
        points="2 7.603 5.125 10.798 10.792 5"
      />
      <polyline
        stroke={strokeColor}
        strokeWidth="1.5"
        points="6.808 9.31 8.263 10.798 13.93 5"
      />
    </g>
  </svg>
)
